export default [
  {
    path: "/order/list/:type?",
    name: "MyOrder",
    meta: {
      title: "我的訂單",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/moblie/order/MyOrder")
  },
  {
    path: "/order/logistics/:id",
    name: "Logistics",
    meta: {
      title: "物流信息",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/order/Logistics")
  },
  {
    path: "/order/detail/:id",
    name: "OrderDetails",
    meta: {
      title: "訂單詳情",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/moblie/order/OrderDetails")
  },
  {
    path: "/order/follow/:id",
    name: "OrderFollowHint",
    meta: {
      title: "关注提示",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/order/followHint")
  },
  {
    path: "/order/submit/:id",
    name: "OrderSubmission",
    meta: {
      title: "提交訂單",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/order/OrderSubmission")
  },
  {
    path: "/order/status/:id/:status",
    name: "PaymentStatus",
    meta: {
      title: "支付狀態",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/order/PaymentStatus")
  },
  {
    path: "/order/refund/:id",
    name: "GoodsReturn",
    meta: {
      title: "申請退貨",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/order/GoodsReturn.vue")
  },
  {
    path: "/order/refund_list",
    name: "ReturnList",
    meta: {
      title: "退貨列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/order/ReturnList.vue")
  },
  {
    path: "/order/qrcode",
    name: "qrCode",
    meta: {
      title: "支付宝付款码",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/order/qrCode.vue")
  },
  {
    path: "/order/openAlipay",
    name: "openAlipay",
    meta: {
      title: "使用支付宝支付",
      keepAlive: true,
      auth: false
    },
    component: () => import("@views/moblie/order/openAlipay.vue")
  },
  {
    path: "/order/union_pay",
    name: "UnionPay",
    meta: {
      title: "使用银联支付",
      keepAlive: true,
      auth: false
    },
    component: () => import("@views/moblie/order/UnionPay.vue")
  }
];
